export { ROLES, RoleName };

enum ROLES {
  ADMIN = 'ADMIN',
  EDUCATION_MANAGER = 'EDUCATION_MANAGER',
  LEARNER = 'LEARNER',
  UNIT_MANAGER = 'UNIT_MANAGER'
}

type RoleName = keyof typeof ROLES;
